import React, { useState } from "react";
import "../styles/AdminDashboard.css";
import WhiteLogo from "../assets/Transparent svg/Bold Logo with Text/White Bold Logo.svg";

const AdminSidebar = ({ activeSection, setActiveSection }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuItems = ["Dashboard", "Dispatches", "Users", "Staff", "Settings"];


  return (
    <>
      {/* Mobile top bar */}
      <div className="mobile-header">
        <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          ☰
        </button>
        <img src={WhiteLogo} alt="Cjet Dispatch Logo" className="mobile-logo" />
      </div>

      {/* Sidebar */}
      <div className={`admin-sidebar ${isOpen ? "open" : ""}`}>
        <div className="logo-container">
          <img src={WhiteLogo} alt="Cjet Dispatch Logo" className="sidebar-logo" />
        </div>

        <ul>
          {menuItems.map((item) => (
            <li
              key={item}
              className={activeSection === item ? "active" : ""}
              onClick={() => {
                setActiveSection(item);
                setIsOpen(false); // close menu after selecting
              }}
            >
              {item}
            </li>
          ))}
        </ul>
      </div>

      {/* Overlay for mobile */}
      {isOpen && <div className="overlay" onClick={() => setIsOpen(false)}></div>}
    </>
  );
};

export default AdminSidebar;
